module.exports = __webpack_public_path__ + "img/g1.e4421d7e.jpg";